import type { TFunction } from 'i18next'
import type { CompetitionFormat } from '../types'
import type { SetupStep } from './steps'

/** A step's name. The time-slot step is Groups for one day and Rounds for longer. */
export function stepLabel(step: SetupStep, format: CompetitionFormat, t: TFunction): string {
  switch (step) {
    case 'about':
      return t('competitionSetup.stepAbout')
    case 'when':
      return t('competitionSetup.stepWhen')
    case 'entry':
      return t('competitionSetup.stepEntry')
    case 'categories':
      return t('competitionSetup.stepCategories')
    case 'slots':
      return format === 'single_day'
        ? t('competitionSetup.stepGroups')
        : t('competitionSetup.stepRounds')
    case 'routes':
      return t('competitionSetup.stepRoutes')
    case 'publish':
      return t('competitionSetup.stepPublish')
  }
}
